<div class="logo-container">
  <img class="logo" [src]="logo" [class.icteam-logo]="this.isICTeam" [class.logo-expanded]="!this.collapsed" />
</div>